import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Typography,
} from "@/common/styles/style";
import { styles } from "./style";
import DataInput from "@/atoms/dataInput";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useSignUpForm } from "@/hooks/useSignUpForm";
import TimeZoneSelect from "@/molecules/timeZoneSelect";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/router/routes";
import RequiredAsterisk from "@/atoms/requiredAsterisk";
import ErrorMessage from "@/atoms/errorMessage";

export default function SignUpPage() {
  const {
    formValues,
    errorMessage,
    showPassword,
    showConfirmPassword,
    setShowPassword,
    setShowConfirmPassword,
    handleChange,
    handleSubmit,
  } = useSignUpForm();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(Routes.LOGIN);
  };

  const inputList = [
    {
      label: "名前",
      field: "name",
      type: "text",
    },
    {
      label: "メールアドレス",
      field: "email",
      type: "text",
    },
    {
      label: "タイムゾーン",
      field: "timezone",
      type: "text",
    },
    {
      label: "パスワード",
      field: "password",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword((prev) => !prev)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      },
    },
    {
      label: "パスワード (確認用)",
      field: "confirmPw",
      type: showConfirmPassword ? "text" : "password",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowConfirmPassword((prev) => !prev)}
              edge="end"
            >
              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      },
    },
  ];

  return (
    <Box sx={styles.container}>
      <Box sx={styles.box}>
        <Typography variant="h3" align="center" marginBottom={2}>
          会員登録
        </Typography>
        <ErrorMessage error={errorMessage} />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          {inputList.map((input, index) =>
            input.label !== "タイムゾーン" ? (
              <DataInput
                key={index}
                datatype="TextField"
                label={
                  <label style={styles.labelFlex}>
                    {input.label}
                    <RequiredAsterisk />
                  </label>
                }
                typographyProps={{
                  sx: styles.text,
                }}
                textProps={{
                  variant: "outlined",
                  type: input.type,
                  sx: styles.input,
                  value: formValues[input.field as keyof typeof formValues],
                  InputProps: input.InputProps,
                }}
                onChange={(value) =>
                  handleChange(input.field as keyof typeof formValues, value)
                }
              />
            ) : (
              <Box key={index}>
                <label style={styles.labelFlex}>
                  {input.label}
                  <RequiredAsterisk />
                </label>
                <TimeZoneSelect
                  value={formValues.timezone}
                  onChange={(value) =>
                    handleChange(
                      "timezone" as keyof typeof formValues,
                      value.toString()
                    )
                  }
                />
              </Box>
            )
          )}
          <Button variant="contained" sx={styles.button} type="submit">
            <Typography variant="button">登録</Typography>
          </Button>
        </form>
        <Button variant="text" onClick={handleBack} sx={styles.back}>
          <Typography variant="button">ログイン画面に戻る</Typography>
        </Button>
      </Box>
    </Box>
  );
}
